import { render, staticRenderFns } from "./ViewFormCompanies.vue?vue&type=template&id=3cebb416&"
import script from "./ViewFormCompanies.vue?vue&type=script&lang=js&"
export * from "./ViewFormCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports